import React, { Component } from 'react';
import { Field, getFormValues, reduxForm } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { bookingFormInitialValues } from '../../store/reducers';
import CounterInput from '../CounterInput';

import { getBoardBasePrice, getNoOfSelectedGuestsByGuestType } from "../../apiHelpers";

class BoardBaseOffer extends Component {

	render() {
		const { boardBase, formValues, guestTypes } = this.props;

		if (!boardBase) return null;

		const price = getBoardBasePrice(boardBase, formValues.currency, false);
		const formattedPrice = getBoardBasePrice(boardBase, formValues.currency);

		return (
			<div className={`room-offer ${this.props.isLast ? 'room-offer--last' : ''}`}>
				<div className="room-offer__text-container">
					<h2 className="room-offer__room-name">{boardBase.name} {price ? ` (+ ${formattedPrice})` : null}</h2>

					<br />

					{Object.values(guestTypes).map((guestType, index) =>
						!guestType.exclude ? <Field
							component={CounterInput}
							name={`boardBase[${boardBase.id}][${guestType.id}]`}
							className="large-input--inline"
							label={guestType.name}
							max={getNoOfSelectedGuestsByGuestType(formValues, guestType.id)}
							key={index}
						/> : ''
					)}
				</div>
			</div>
		);
	}
}

export default compose(
	connect(state => ({
		formValues: getFormValues('bookingForm')(state),
		guestTypes: state.app.guestTypes,
	})),
	reduxForm({
		form: 'bookingForm',
		initialValues: bookingFormInitialValues,
		destroyOnUnmount: false,
	}),
)(BoardBaseOffer);



// WEBPACK FOOTER //
// ./src/components/BoardBases/BoardBaseOffer.jsx